export default __webpack_public_path__ + "static/media/Starport-Menu-Logo.ebb2639c.svg";